/** Auto-refetch when opening Auditors / Plan Session / Manage Assignments. */
export const PEOPLE_ROSTER_STALE_MS = 5 * 60 * 1000;

/** Do not trust a leftover snapshot older than this (e.g. persisted session). */
export const PEOPLE_ROSTER_HARD_EXPIRE_MS = 24 * 60 * 60 * 1000;

/**
 * @param {number|null} lastFetchedAt
 * @param {{ force?: boolean, now?: number }} [opts]
 * @returns {'fresh'|'stale'|'expired'|'missing'}
 */
export function peopleRosterFreshness(lastFetchedAt, opts = {}) {
  if (opts.force) return 'expired';
  if (lastFetchedAt == null || lastFetchedAt === 0) return 'missing';
  const now = opts.now ?? Date.now();
  const age = now - lastFetchedAt;
  if (age >= PEOPLE_ROSTER_HARD_EXPIRE_MS) return 'expired';
  if (age >= PEOPLE_ROSTER_STALE_MS) return 'stale';
  return 'fresh';
}

/** Auto-pull when opening a people-sensitive screen (stale or expired or never loaded). */
export function shouldAutoRefreshPeopleRoster(lastFetchedAt, opts = {}) {
  const state = peopleRosterFreshness(lastFetchedAt, opts);
  return state !== 'fresh';
}
